var map = {
	"./en/bio.ts": [
		94298,
		4298
	],
	"./en/common.ts": [
		46125,
		6125
	],
	"./en/my.ts": [
		18254,
		8254
	],
	"./en/priority.ts": [
		80007,
		2388
	],
	"./es/bio.ts": [
		24885,
		4885
	],
	"./es/common.ts": [
		38608,
		8608
	],
	"./es/my.ts": [
		90311,
		311
	],
	"./es/priority.ts": [
		83021,
		3021
	],
	"./index.ts": [
		9967
	],
	"./ko/bio.ts": [
		11831,
		1831
	],
	"./ko/common.ts": [
		97606,
		7606
	],
	"./ko/my.ts": [
		50733,
		733
	],
	"./ko/priority.ts": [
		78063,
		8063
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89639;
module.exports = webpackAsyncContext;